
import Vue from 'vue';
import Component from 'vue-class-component';
import ConfirmationModel from './ConfirmationModel';
import { Prop } from 'vue-property-decorator';

@Component
export default class ConfirmFolders extends Vue {
    @Prop({
        type: ConfirmationModel,
        required: true,
    })
    public confirmationModel!: ConfirmationModel;
    public message: string = '';
    public dialogOpen: boolean = false;

    public mounted() {
        this.confirmationModel.on('confirm', (message: string) => {
            console.log('confirmation');
            this.dialogOpen = true;
            this.message = message;
        });
    }
}

export { ConfirmationModel };
